"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RxWrapperBase = void 0;
const react_1 = __importDefault(require("react"));
const rxjs_1 = require("rxjs");
const lens_1 = require("@rixio/lens");
const wrapped_1 = require("@rixio/wrapped");
class RxWrapperBase extends react_1.default.Component {
    constructor(props) {
        super(props);
        this._mounted = false;
        this.subscriptions = new Map();
        this._state = this.extractProps(props);
        this.doSubscribe({}, this._state);
        this.state = this._state;
    }
    componentDidMount() {
        this._mounted = true;
    }
    componentWillUnmount() {
        this.subscriptions.forEach(([subscription], key, map) => {
            subscription.unsubscribe();
            map.delete(key);
        });
        this._mounted = false;
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.props !== nextProps) {
            const oldProps = this.extractProps(this.props);
            const newProps = this.extractProps(nextProps);
            this.doUnsubscribe(oldProps, newProps);
            this.doSubscribe(oldProps, newProps);
            this.setState(this._state);
        }
        return true;
    }
    render() {
        var _a, _b;
        const result = wrapped_1.toWrapped(this.checkObservables());
        switch (result.status) {
            case "fulfilled":
                return react_1.default.createElement(this.extractComponent(this.props), result.value);
            case "pending":
                const pending = (_a = this.extractRxBaseProps(this.props)) === null || _a === void 0 ? void 0 : _a.pending;
                if (pending) {
                    return pending;
                }
                return null;
            case "rejected":
                const rejected = (_b = this.extractRxBaseProps(this.props)) === null || _b === void 0 ? void 0 : _b.rejected;
                if (rejected && typeof rejected === "function") {
                    return rejected(result.error, result.reload);
                }
                else if (rejected) {
                    return rejected;
                }
                else {
                    return null;
                }
        }
    }
    doSubscribe(oldProps, props) {
        walk(props, (value, lens) => {
            if (value instanceof rxjs_1.Observable) {
                let oldValue;
                try {
                    oldValue = lens.get(oldProps);
                }
                catch (e) {
                    oldValue = undefined;
                }
                if (oldValue !== value) {
                    const s = value.subscribe(plain => this.handle(lens, wrapped_1.toWrapped(plain)), error => this.handle(lens, wrapped_1.createRejectedWrapped(error)));
                    this.subscriptions.set(value, [s, lens]);
                }
            }
            else {
                this._state = lens.set(value, this._state);
            }
        });
    }
    doUnsubscribe(oldProps, newProps) {
        walk(oldProps, (value, lens) => {
            if (value instanceof rxjs_1.Observable && lens.get(newProps) !== value) {
                this.subscriptions.get(value)[0].unsubscribe();
                this.subscriptions.delete(value);
            }
        });
    }
    handle(lens, value) {
        const newState = lens.set(value, this._state);
        if (newState !== this._state) {
            this._state = newState;
            if (this._mounted) {
                this.setState(newState);
            }
        }
    }
    checkObservables() {
        let foundPending = false;
        const rejected = [];
        let props = this._state;
        walk(this._state, (value, lens) => {
            if (value instanceof rxjs_1.Observable) {
                foundPending = true;
            }
            const wrapped = wrapped_1.toWrapped(value);
            if (wrapped.status === "rejected") {
                rejected.push(wrapped);
            }
            else if (wrapped.status === "pending") {
                foundPending = true;
            }
            else {
                props = lens.set(wrapped.value, props);
            }
        });
        if (foundPending)
            return wrapped_1.pendingWrapped;
        if (rejected.length > 0) {
            const reload = () => {
                rejected.forEach(r => r.reload());
                this.subscriptions.forEach(([s, lens], obs) => {
                    s.unsubscribe();
                    const newSubscription = obs.subscribe(plain => this.handle(lens, wrapped_1.toWrapped(plain)), error => this.handle(lens, wrapped_1.createRejectedWrapped(error)));
                    this.subscriptions.set(obs, [newSubscription, lens]);
                });
            };
            return wrapped_1.createRejectedWrapped(rejected[0].error, reload);
        }
        return props;
    }
}
exports.RxWrapperBase = RxWrapperBase;
function walk(props, handler) {
    for (const key in props) {
        if (props.hasOwnProperty(key)) {
            const prop = props[key];
            if (key === "children" && Array.isArray(prop)) {
                for (let i = 0; i < prop.length; i++) {
                    const result = handler(prop[i], lens_1.Lens.compose(lens_1.Lens.key("children"), lens_1.Lens.index(i)));
                    if (result !== undefined) {
                        return result;
                    }
                }
            }
            else {
                const result = handler(prop, lens_1.Lens.key(key));
                if (result !== undefined) {
                    return result;
                }
            }
        }
    }
}
